import api from './api';

export interface Proveedor {
    nroProveedor: number;
    nombre: string;
    direccion?: string;
    codigoCiudad?: number;
    telefono1?: string;
    telefono2?: string;
    fax?: string;
    email?: string;
    tipoIva?: string;
    cuit?: string;
    dni?: number;
    contacto?: string;
    descuento?: number;
    nroCuenta?: number;
    fechaAlta?: string;
    fechaBaja?: string;
    plazoEntrega?: number;
    codigoRuta?: number;
    saldo?: number;
    condVta?: string;
    tipoProveedor?: string;
    notas?: string;
    notas2?: string;
    activo?: boolean;
    sitIB?: string;
    esPersHumSucIndig?: boolean;
    nroCuentaCompras?: number;
    codigoRamoProv?: string;
    /** Porcentaje de conversión de cantidades (0–100). 0/null = no participa. */
    porcCantB?: number | null;
}

interface ProveedorSearchParams {
    searchTerm?: string;
    pageNumber: number;
    pageSize: number;
}

interface ProveedorPagedResult {
    items: Proveedor[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

const proveedorService = {
    getProveedores: async (params: ProveedorSearchParams): Promise<ProveedorPagedResult> => {
        const response = await api.get<ProveedorPagedResult>('/api/proveedores', { params });
        return response.data;
    },

    getProveedor: async (nroProveedor: number): Promise<Proveedor> => {
        const response = await api.get<Proveedor>(`/api/proveedores/${nroProveedor}`);
        return response.data;
    },

    createProveedor: async (proveedor: any): Promise<Proveedor> => {
        // Se usa la ruta pedida explícitamente por el usuario
        const response = await api.post<Proveedor>('/api/Proveedores', proveedor);
        return response.data;
    },

    updateProveedor: async (nroProveedor: number, proveedor: Proveedor): Promise<void> => {
        await api.put(`/api/proveedores/${nroProveedor}`, proveedor);
    },

    puedeEliminar: async (nroProveedor: number) => {
        const response = await api.get<{ canDelete: boolean; motivos?: string[]; message?: string }>(
            `/api/proveedores/${nroProveedor}/puede-eliminar`
        );
        return response.data;
    },

    deleteProveedor: async (nroProveedor: number): Promise<void> => {
        await api.delete(`/api/proveedores/${nroProveedor}`);
    },

    getProximoNumero: async (): Promise<number> => {
        const response = await api.get<number>('/api/Proveedores/ProximoNumero');
        return response.data;
    }
};

export default proveedorService;


